<template>
  <div v-if="show">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
      <van-swipe-item>
        <van-image
          width="100%"
          height="100%"
          fit="contain"
          src="/static/images/img_qkier.jpg"
        />
      </van-swipe-item>
    </van-swipe>

    <div style="padding: 10px" v-if="hasActivity">
      <div style="white-space: pre-wrap; text-align: center; font-size: 16pt">
        创维轻客-扫码领券
      </div>
      <div style="text-align: left">
        <van-field
          v-model="phone"
          type="tel"
          maxlength="11"
          label="手机号"
          placeholder="请输入手机号"
        />
        <van-field
          v-model="verifyCode"
          type="digit"
          center
          clearable
          label="短信验证码"
          placeholder="请输入短信验证码"
          maxlength="6"
        >
          <template #button>
            <van-button
              size="small"
              type="primary"
              color="#46C9BA"
              v-on:click="sendVerifyCode"
              >发送验证码</van-button
            >
          </template>
        </van-field>

        <div style="padding-top: 35px"></div>
        <van-button
          type="primary"
          color="#46C9BA"
          block
          v-on:click="verifyAccount"
          >立即领取优惠券</van-button
        >
        <div style="padding-top: 20px"></div>
        <div
          v-html="tipsContent"
          style="
            white-space: pre-wrap;
            text-align: left;
            font-size: 10pt;
            color: red;
          "
        ></div>
      </div>
      <!-- <div style="white-space: pre-wrap; text-align: center">
        <van-list @load="onLoad"></van-list>
      </div> -->
    </div>
    <div v-else class="error">
      <img src="../../assets/empty.png" />
      <div>无效的活动</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      phone: "",
      verifyCode: "",
      tipsContent: "",
      activityId: "",
      hasActivity: true,
      show: false
    };
  },
  mounted() {
    console.log("onload...");
    this.init();
  },
  methods: {
    init() {
      this.activityId = new URLSearchParams(window.location.hash.split('?')[1] || '').get('activityId');
      let data = new FormData();
      data.append("activityId", this.activityId);
      console.log(data);

      this.$axios
        .post("/api/usershare/invite/get-activity-info", data)
        .then(res => {
          if (res.data.success) {
            this.hasActivity = res.data.userObject.hasActivity;
            this.tipsContent = res.data.userObject.showHtml;
          } else {
            this.$toast.fail("操作失败，原因：" + res.data.msg + "!");
          }
          this.show = true;
        })
        .catch(error => {
          this.$toast.fail("操作失败!");
        });
    },
    sendVerifyCode() {
      if (this.phone == null || this.phone.length != 11) {
        this.$toast.fail("手机号格式不正确!");
        return;
      }

      let data = new FormData();
      data.append("phone", this.phone);

      this.$axios
        .post("/api/usershare/invite/send-verifycode", data)
        .then(res => {
          if (res.data.success) {
            this.$toast.success("验证码发送成功!");
          } else {
            this.$toast.fail("操作失败，原因：" + res.data.msg + "!");
          }
        })
        .catch(error => {
          this.$toast.fail("操作失败!");
        });
    },

    verifyAccount() {
      if (this.phone == null || this.phone.length != 11) {
        this.$toast.fail("手机号格式不正确!");
        return;
      }

      if (this.verifyCode == null || this.verifyCode.length != 6) {
        this.$toast.fail("请输入正确的短信验证码!");
        return;
      }

      let activityId = this.$route.query.activityId;

      if (typeof activityId === "undefined") {
        activityId = "";
      }

      let data = new FormData();
      data.append("phone", this.phone);
      data.append("verifyCode", this.verifyCode);
      data.append("activityId", activityId);

      this.$axios
        .post("/api/usershare/invite/get-coupon-submit", data)
        .then(res => {
          if (res.data.success) {
            this.$dialog
              .alert({
                message: "优惠券领取成功"
              })
              .then(() => {
                // on close，跳转到轻客下载页面
                window.location.href = "weixin://dl/business/?appid=wx15d0b7203996b904&path=pages/home/home";
              });
            //跳转至轻客下载页面
          } else {
            this.$toast.fail("领取失败，原因：" + res.data.msg + "!");
          }
        })
        .catch(error => {
          this.$toast.fail("领取失败!");
        });
    }
  }
};
</script>

<style>
.error {
  margin-bottom: 20px;
  padding-bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a2a2a2;
}
.error > img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/share/GetCouponShareInvite.vue